module.exports = __webpack_public_path__ + "static/media/google-tag-manager-cloud-run.04047ec0.md";